export default "__VITE_ASSET__fe5f17ab__"